import * as React from "react";
import { NotifyContext } from "../notifications/Provider";

// notify({title, description, type, onClose, onMore})
function useNotify() {
  return React.useContext(NotifyContext);
}

export default useNotify;